<mat-card class="mb-4 audit-trail-container">
  <app-expandable-panel [icon]="{name: 'arrow-circle-down', type: IconType.SVG, rotate: true }">
    <mat-card-header toggle class="py-3 pr-0">
      <h6 class="my-0">{{ title }}</h6>
    </mat-card-header>

    <app-state-section [state]="sectionState" [errorStateLabel]="'ErrorMessages.ErrorHappened' | translate">
      <mat-card-content class="mt-0">
        <mat-divider class="mb-3"></mat-divider>
        <div class="wrapper">
          <app-row class="no-gutters">
            <app-col [cols]="isOldJsonEmpty ? 12 : 7 " class="bordered">
              <div class="expanded-items">
                <mat-accordion>
                  <mat-expansion-panel
                    *ngFor="let item of AuditTrailsDateRangeType | enumToArray; first as isFirst"
                    class="item m-0"
                    [expanded]="isFirst"
                    (afterExpand)="getAuditTrails(item.value);"
                    (afterCollapse)="oldJson = { }; currentRowIndex = null;"
                  >
                    <mat-expansion-panel-header class="item__header">
                      <div>{{ 'Enum.AuditTrailsDateRangeType.' + item.value | translate }}</div>
                    </mat-expansion-panel-header>
                    <div class="item__body">
                      <div
                        *ngFor="let log of logs; let i = index;"
                        class="item__action row"
                        (click)="oldJson = log?.oldJson; currentRowIndex = i;"
                        [ngClass]="{'colored-background': currentRowIndex === i }"
                      >
                        <div class="col-auto">
                          <span class="bold-text">{{ log.createdBy.dropDownDisplayName }}</span>
                          <ng-container
                            *ngIf="log.action !== AuditTrailActions.ShipmentCreate && log.action !== AuditTrailActions.TruckCreate && log.action !== AuditTrailActions.DriverCreate"
                          >
                            {{ 'General.Changed' | translate }}
                          </ng-container>
                          <span class="bold-text">{{ 'Enum.AuditTrailActions.' + log.action | translate }}</span>
                        </div>
                        <div class="col-auto ml-auto bold-text">{{ (log.createdAt | date: 'MMM d, y, h:mm:ss a') || '_____' }}</div>
                      </div>
                      <div *ngIf="!logs.length" style="height: 80px"></div>
                    </div>
                  </mat-expansion-panel>
                </mat-accordion>
              </div>
            </app-col>

            <app-col cols="5" *ngIf="!isOldJsonEmpty">
              <div class="content-area">
                <div class="scrollable scrollable--y" style="margin: 0 -1rem; padding: 0 1rem; max-height: 320px; overflow-x: hidden">
                  <span class="content-area__label">{{ "AuditTrail.Data" | translate }}</span>

                  :
                  <pre> {{ oldJson | json }} </pre>
                </div>
              </div>
            </app-col>
          </app-row>
        </div>
      </mat-card-content>
    </app-state-section>
  </app-expandable-panel>
</mat-card>
